import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ServiceCard.module.css';

export default function ServiceCard({ icon, title, desc, features, linkTo }) {
  const content = (
    <>
      <div className={styles.icon}>{icon}</div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.desc}>{desc}</p>
      {features && (
        <ul className={styles.features}>
          {features.map((f, i) => (
            <li key={i} className={styles.feature}>
              <span className={styles.bullet}>▸</span> {f}
            </li>
          ))}
        </ul>
      )}
      {linkTo && (
        <div className={styles.more}>Detayları Gör →</div>
      )}
    </>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className={`${styles.card} ${styles.cardLink}`}>
        {content}
      </Link>
    );
  }

  return <div className={styles.card}>{content}</div>;
}
